<template>
  <management-page :pageName="pageName" :menu="menu" class="management" />
</template>

<script>
import { mapActions } from "vuex";
import { managementViewMixin } from "@/mixins/management/managementViewMixin";
import ManagementPage from "@/components/Management/Management";
import DataSVG from "@/assets/management/data.svg";
import ManagementSVG from "@/assets/management/management.svg";

export default {
  name: "AssetReservationManagement",

  components: { ManagementPage },

  mixins: [managementViewMixin],

  computed: {
    /**
     * Determine the page title
     * @returns {VueI18n.TranslateResult}
     */
    pageName() {
      return this.$i18n.t("AssetReservationManagement");
    },

    /**
     * Determines the menu available in the sidebar on the page
     * @returns {[{submenu: [{route: string, dev: boolean, name: string, disabled: boolean}, {route: string, dev: boolean, name: string, disabled: boolean}, {route: string, dev: boolean, name: string, disabled: boolean}], name: VueI18n.TranslateResult, icon, disabled: boolean}, {submenu: [{route: string, dev: boolean, name: string, disabled: boolean}], name: string, icon, disabled: boolean}]}
     */
    menu() {
      return [
        {
          name: this.$i18n.t("Management"),
          icon: ManagementSVG,
          disabled: false,
          submenu: [
            {
              name: this.$i18n.tc("AssetReservation", 2),
              route: "asset-reservations",
              disabled: !this.userHasFibercloudPermission(
                "asset_reservation_list"
              ),
              dev: false
            },
            {
              name: this.$i18n.tc("ImportNoun", 1),
              route: "asset-reservation-import",
              disabled: false,
              dev: true
            },
            {
              name: this.$i18n.tc("ExportNoun", 1),
              route: "asset-reservation-export",
              disabled: false,
              dev: true
            }
          ]
        },
        {
          name: this.$i18n.tc("Template", 2),
          icon: DataSVG,
          disabled: false,
          submenu: [
            {
              name: this.$i18n.tc("ReservationTemplate", 2),
              route: "reservation-templates",
              disabled: !this.userHasFibercloudPermission(
                "asset_reservation_template_list"
              ),
              dev: false
            }
          ]
        }
      ];
    }
  },

  created() {
    if (this.$store.getters.getAllObjectTypesProperties.length === 0) {
      this.FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS();
    }
  },

  methods: {
    ...mapActions(["FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS"])
  }
};
</script>



// WEBPACK FOOTER //
// src/views/AssetReservationManagement.vue